import {
  FETCH_GABARITS,
  FETCH_GABARITS_COMPLETED,
  FETCH_GABARITS_FAILED,
  FETCH_GABARIT,
  FETCH_GABARIT_COMPLETED,
  FETCH_GABARIT_FAILED,
  SAVE_GABARIT,
  SAVE_GABARIT_COMPLETED,
  SAVE_GABARIT_FAILED,
  RENAME_GABARIT,
  RENAME_GABARIT_COMPLETED,
  RENAME_GABARIT_FAILED,
  DELETE_GABARIT,
  DELETE_GABARIT_COMPLETED,
  DELETE_GABARIT_FAILED,
  SET_SELECTED_GABARIT,
} from "./actions";

const initialState = {
  list: [],
  selected: null,
  loading: false,
  isInitialized: false,
};

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GABARITS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_GABARITS_COMPLETED:
      return {
        ...state,
        loading: false,
        isInitialized: true,
        list: action.payload?.result || [],
      };
    case FETCH_GABARITS_FAILED:
      return {
        ...state,
        loading: false,
      };

    case FETCH_GABARIT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_GABARIT_COMPLETED: {
      const fullGabarit = action.payload?.result;
      return {
        ...state,
        loading: false,
        selected: fullGabarit || state.selected,
      };
    }
    case FETCH_GABARIT_FAILED:
      return {
        ...state,
        loading: false,
      };

    case SAVE_GABARIT:
      return {
        ...state,
        loading: true,
      };
    case SAVE_GABARIT_COMPLETED: {
      const newGabarit = action.payload?.result;
      return {
        ...state,
        loading: false,
        list: newGabarit ? [...state.list, newGabarit] : state.list,
      };
    }
    case SAVE_GABARIT_FAILED:
      return {
        ...state,
        loading: false,
      };

    case RENAME_GABARIT:
      return {
        ...state,
        loading: true,
      };
    case RENAME_GABARIT_COMPLETED: {
      const updatedGabarit = action.payload?.result;
      return {
        ...state,
        loading: false,
        list: updatedGabarit
          ? state.list.map((g) =>
              g.id === updatedGabarit.id ? { ...g, name: updatedGabarit.name } : g
            )
          : state.list,
        // Synchroniser selected si c'est le gabarit renommé
        selected:
          updatedGabarit && state.selected?.id === updatedGabarit.id
            ? { ...state.selected, name: updatedGabarit.name }
            : state.selected,
      };
    }
    case RENAME_GABARIT_FAILED:
      return {
        ...state,
        loading: false,
      };

    case DELETE_GABARIT:
      return {
        ...state,
        loading: true,
      };
    case DELETE_GABARIT_COMPLETED: {
      const deletedId = action.payload?.id;
      return {
        ...state,
        loading: false,
        list: deletedId
          ? state.list.filter((g) => g.id !== deletedId)
          : state.list,
        selected: state.selected?.id === deletedId ? null : state.selected,
      };
    }
    case DELETE_GABARIT_FAILED:
      return {
        ...state,
        loading: false,
      };

    case SET_SELECTED_GABARIT:
      return {
        ...state,
        selected: action.payload,
      };

    default:
      return state;
  }
};

export default reducers;
